import { PlainSessionStorageDriver, RunTimeDriver } from "@taager/cache";

export * from "./bot-poison";
export * from "./http";
export * from "./performance";
export * from "./utils";

export const sessionDriver = new PlainSessionStorageDriver();

let runtimeDriver: RunTimeDriver | undefined;

export function getRuntimeCache() {
  if (!runtimeDriver) {
    runtimeDriver = new RunTimeDriver();
  }

  return runtimeDriver;
}

export function getSessionCache() {
  return sessionDriver;
}
